<template>
  <el-dialog
    title="请选择指定快递"
    :visible.sync="visibleDialog"
    width="270px"
    top="calc(50vh - 280px)"
    class="pop-dialog pop-set-express"
    append-to-body>
    <el-radio-group v-model="radio" class="radio-group">
      <el-radio :label="item.dictId" v-for="item in expressList" :key="item.dictId">{{ item.dictName }}</el-radio>
    </el-radio-group>
    <template slot="footer">
      <el-button @click="visibleDialog = false" size="mini">取 消</el-button>
      <el-button type="primary" @click="onConfirm" size="mini">确 定</el-button>
    </template>
  </el-dialog>
</template>
<script>
export default {
  name: 'popSetExpress',
  data () {
    return {
      visibleDialog: false,
      orderIds: '',
      radio: '',
      expressList:[],
    }
  },
  computed: {
    // expressList() {
    //   return this.$parent.logisticsList
    // }
  },
  methods: {
    // 批量设置不需要回显
    show(data) {
        console.log('show:',data)
        if (typeof data === 'object') {
          let radio = data.radio?String(data.radio):''
          this.radio = radio
          this.orderIds = data.orderIds
          this.expressList = data.expressList
        }else {
          this.radio = ''
          this.orderIds = ''
        }
        this.visibleDialog = true
      },
    // 确认修改
    onConfirm() {
      if (!this.radio ) {
        this.$message.warning('请选择快递公司')
        return
      }
      let data = {
        orderIds: this.orderIds,
        logisticsCompanyId:this.radio
      }
      this.$emit('hasSetExpress', data)
      this.visibleDialog = false
    },
  },
}
</script>
<style lang='scss'>
.pop-set-express{
  .radio-group{
    padding: 10px 0  0;
    .el-radio{
      line-height: 32px;
      display: block;
    }
    .el-radio__label{
      font-size: 12px;
      font-weight: normal;
      padding-left: 3px;
      color: #333;
    }
  }
}
</style>